<template>
    <div>
        <div id="table_box">
            <div class="search_box">
                <el-form :inline="true" ref="form" :model="form">
                    <el-row>
                        <el-col :span="4">
                        <el-form-item label="项目名称" v-if="innerTableType == 8">
                            <el-input v-model="form.companyName" size="mini"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;" v-if="innerTableType == 10">
                        <el-form-item label="订单名称">
                            <el-input v-model="form.orderName" size="mini"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;" v-if="innerTableType == 11">
                        <el-form-item label="派工单名称">
                            <el-input v-model="form.orderName" size="mini"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;">
                        <el-form-item label="合同名称">
                            <el-input v-model="form.contactName" size="mini"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;">
                        <el-form-item label="合同编号">
                            <el-input v-model="form.contactCode" size="mini"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;">
                        <el-form-item label="状态" v-if="innerTableType == 9">
                            <el-select v-model="form.detailStatus" placeholder="请选择" size="mini">
                                <el-option label="已支付" value="2"></el-option>
                                <el-option label="未支付" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态" v-else-if="innerTableType == 8">
                            <el-select v-model="form.contractStatus" placeholder="请选择" size="mini">
                                <el-option label="待审核" value="待审核"></el-option>
                                <el-option label="审核中" value="审核中"></el-option>
                                <el-option label="已发布" value="已发布"></el-option>
                                <el-option label="已结算" value="已结算"></el-option>
                                <el-option label="已清算" value="已清算"></el-option>
                            </el-select>
                        </el-form-item>
                        </el-col>
                        <el-col :span="4" style="margin-left:10px;">
                        <el-form-item>
                            <!-- <el-button v-if="innerTableType == 11" type="primary" class="fr" size="mini" @click="settle(null,'4')" style="color: white;font-size: 12px;margin-top: 5px;margin-left: 10px">新增</el-button> -->
                            <el-button type="primary" class="fr" size="mini" @click="getData" style="color: white;font-size: 12px;margin-top: 5px">查询</el-button>
                        </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div v-if="innerTableType == 7" key="7">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="项目名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同编号" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="供应商分类">
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="服务城市">
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 8" key="8">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="companyName"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="contactName"
                        label="合同名称"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="contactCode"
                        label="合同编号"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="signContactAmount"
                        label="合同含税金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="contractStatus"
                        label="合同状态"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="signTime"
                        label="签约时间">
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="contract(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 9" key="9">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="contactName"
                        label="合同名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="nodeType"
                        label="款项名称">
                    </el-table-column>
                    <el-table-column
                        width="150px"
                        prop="planPaymentDate"
                        label="付款时间">
                    </el-table-column>
                    <el-table-column
                        prop="paymentAmount"
                        label="应付金额">
                    </el-table-column>
                    <el-table-column
                        prop="paidAmount"
                        label="已付金额">
                    </el-table-column>
                    <el-table-column
                        prop="planBalanceAmount"
                        label="应付未付金额">
                    </el-table-column>
                    <el-table-column
                        prop="detailStatus"
                        label="状态">
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.planBalanceAmount!==0" type="text" @click="apply(scope.row)">发起申请</el-button>
                            <el-button v-else type="text" @click="check(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 10" key="9">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="orderName"
                        label="订单名称"
                        min-width="250"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="contactName"
                        label="合同名称"
                        min-width="250"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="amountWithTax"
                        label="订单总额"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="setupTime"
                        label="接收时间"
                        width="150">
                    </el-table-column>
                     <!-- <el-table-column
                        prop="approveRemarks"
                        label="审核意见"
                        min-width="200"
                        show-overflow-tooltip>
                    </el-table-column> -->
                    <el-table-column width="300" label="操作" align="center" class="">
                        <template slot-scope="scope">
                           <el-button v-if="scope.row.orderStatus == 2" type="text" @click="settle(scope.row,'6')">查看</el-button>
                           <el-button v-if="scope.row.orderStatus == 4" :disabled="scope.row.dateTemp > 0" type="text" @click="settle(scope.row,'7')">确认订单</el-button>
                           <el-button v-if="scope.row.orderStatus == 7"  type="text" @click="settle(scope.row,'8')">已确认</el-button>
                           <el-button v-if="scope.row.orderStatus == 7" :disabled="scope.row.dateTemp <= 0" type="text"  @click="settle(scope.row,'71')">发起结算申请</el-button>
                           <!-- <el-popover
                                placement="top-start"
                                title=""
                                width="200"
                                trigger="hover">
                                <div class="" style="font-size:12px;">发起结算申请在确认订单【30】天后可操作</div>
                                <i slot="reference" class="el-icon-warning"></i>
                            </el-popover> -->

                      </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 11" key="11">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="contractName"
                        label="合同名称"
                        min-width="200"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="projectNoticeName"
                        label="派工单名称"
                        min-width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="amountWithTax"
                        label="结算额"
                        width="120">
                    </el-table-column>
                    <!-- <el-table-column
                        prop="paidAmount"
                        label="合同已付金额"
                        width="120">
                    </el-table-column> -->
                    <!-- <el-table-column
                        prop="amountWithTax"
                        label="申请金额"
                        width="100">
                    </el-table-column> -->
                    <el-table-column
                        prop="orderStatus"
                        label="状态"
                        width="100">
                        <template slot-scope="scope">
<!--                            "订单状态(0 编制中 1审核中 2已完成 3已驳回)")-->
                            <span v-if="scope.row.projectNoticeStatus == 4 && scope.row.orderStatus == 0">编制中</span>
                            <span v-if="(scope.row.projectNoticeStatus == 4 && scope.row.orderStatus == 3) ||
                                        (scope.row.projectNoticeStatus == 5 && scope.row.orderStatus == 3) ||
                                        (scope.row.projectNoticeStatus == 1 && scope.row.orderStatus == null)">驳回编辑</span>
                            <!-- <span v-if="scope.row.projectNoticeStatus==2">审批中</span> -->
                            <span v-if="scope.row.projectNoticeStatus==3 && scope.row.orderStatus == null">待确认</span>
                            <span v-if="scope.row.projectNoticeStatus==4 && scope.row.orderStatus == null">已确认</span>
                            <span v-if="(scope.row.projectNoticeStatus == 4|| scope.row.projectNoticeStatus == 6)&& scope.row.orderStatus == 1">审批中</span>
                            <span v-if="scope.row.projectNoticeStatus==7 && scope.row.orderStatus == 4">审批通过</span>
                            <span v-if="scope.row.orderStatus==2 && scope.row.projectNoticeStatus==7">已完成</span>
                            <span v-if="scope.row.projectNoticeStatus==2 && scope.row.orderStatus==null">派工单审批中</span>
                            <span v-if="scope.row.projectNoticeStatus==5 && scope.row.orderStatus==1">结算单审批中</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="approveRemarks"
                        label="审核意见"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="150" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.projectNoticeStatus == 3 && scope.row.orderStatus == null" type="text" @click="settle(scope.row,'9')">确认</el-button>
                            <el-button v-if="scope.row.projectNoticeStatus == 4 && scope.row.orderStatus == null" type="text" @click="settle(scope.row,'3')">发起验收申请</el-button>
                            <el-button v-if="(scope.row.projectNoticeStatus == 4 && scope.row.orderStatus == 0) || (scope.row.projectNoticeStatus == 4 && scope.row.orderStatus == 3) || (scope.row.projectNoticeStatus == 5 && scope.row.orderStatus == 3)" type="text" @click="settle(scope.row,'10')">编辑</el-button>
                            <!-- <el-button v-if="scope.row.orderStatus==0 || scope.row.orderStatus==3" type="text" @click="deleteContractForJS(scope.row)">删除</el-button> -->
                            <!-- scope.row.projectNoticeStatus==4 ||scope.row.orderStatus==1 ||  -->
                            <el-button v-if="(scope.row.orderStatus==2 && scope.row.projectNoticeStatus==7) ||
                                             (scope.row.orderStatus==1 && (scope.row.projectNoticeStatus==4 || scope.row.projectNoticeStatus==6)) ||
                                             (scope.row.projectNoticeStatus==2 && scope.row.orderStatus==null) ||
                                             (scope.row.projectNoticeStatus==5 && scope.row.orderStatus==1) ||
                                             (scope.row.projectNoticeStatus == 1 && scope.row.orderStatus == null)" type="text" @click="settle(scope.row,'1')">查看</el-button>
                           <el-button v-if="scope.row.orderStatus==4 && scope.row.projectNoticeStatus==7" type="text" @click="settle(scope.row,'5')">发起付款申请</el-button>
                           <!-- <el-button v-if="scope.row.orderStatus==2 && scope.row.projectNoticeStatus==7" type="text" @click="settle(scope.row,'5')">发起付款申请</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="float: right;margin-top: 10px;">
                <el-pagination
                    background
                    layout="prev, pager, next,jumper"
                    @current-change="pageChange"
                    :current-page.sync="this.form.pageNumber"
                    :page-size="this.form.pageSize"
                    :total="dataCount">
                </el-pagination>
            </div>
            <div style="height: 50px;margin-bottom: 50px"></div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'bidTable',
        data(){
            return {
                data: '',
                form: {
                    "orderName": null,
                    "contactCode": null,
                    "contactName": null,
                    "contractStatus": null,
                    "detailStatus": null,
                    "nodeName": null,
                    "orderCode": null,
                    "orderName": null,
                    "orderStatus": null,
                    "pageFlag": 1,
                    "pageNumber": 1,
                    "pageSize": 10,
                    "projectName": null
                },
                tableData: [],
                dataCount:0,
                tableHeaderStyle:{
                    'background-color': '#F6F6F6',
                    'height': '40px',
                    'color': '#333333',
                },
                innerTableType:8
            }
        },
        components: {
        },
        created(){
            this.getData()
        },
        props:{
        },
        methods:{
            check(val){
                window.open('#/contract/check/'+val.id)
            },
            apply(val){
                window.open('#/contract/apply/'+val.id)
            },
            settle(val,type){
                if(type == 3) {
                   window.open('#/settle/'+3+'/'+val.id)
                }else if (type == 10){
                    window.open('#/settle/'+10+'/'+ val.orderId)
                } else if (type == 1) {
                    var isOrderId = val.orderId ? val.orderId : val.id;
                    window.open('#/settle/'+1+'/'+ isOrderId)
                } else if (type == 5) {
                    if (val.sourceType == 2) {
                        window.open('#/settle/'+5+'/'+ val.id)
                    } else {
                        window.open('#/settle/'+5+'/'+ val.orderId)
                    }
                } else if(type == 9) {
                    window.open('#/settle/'+9+'/'+ val.id)
                } else if(type == 71) {
                    window.open('#/settle/'+71+'/'+ val.id)
                } else {
                     window.open('#/settle/'+type+'/'+ val.id)
                }
                // if (val.orderId) {
                //     window.open('#/settle/'+10+'/'+ val.orderId)
                // } else {
                //     window.open('#/settle/'+3+'/'+val.id)
                // }
                // if (data == 10) {

                // }
                // console.log(val.id)
                // if(type == 4){
                //     window.open('#/settle/add')
                // }else {
                //     window.open('#/settle/'+type+'/'+val.id)
                // }
            },
            // 订单确认
            // confirm () {
            //     this.$confirm('确定确认订单吗?',{
            //         type:'warning',
            //         callback:(action)=>{
            //             if(action == 'confirm'){
            //                 this.$root.getFunc('/v1/outerformflowHS/deleteContractForJS?orderId='+val.id,(res)=>{
            //                     if(res.code == 1){
            //                         this.$message.success(res.msg);

            //                     }
            //                 });
            //             }
            //         }
            //     });
            // },
            deleteContractForJS(val){
            this.$confirm('确定删除吗?',{
                type:'warning',
                callback:(action)=>{
                    if(action == 'confirm'){
                        this.$root.getFunc('/v1/outerformflowHS/deleteContractForJS?orderId='+val.id,(res)=>{
                            if(res.code == 1){
                                this.$message.success(res.msg);

                            }
                        });
                    }
                }
            });
        },

            contract(val){
                window.open('#/contract/see/'+val.id)
            },
            order(val){
                window.open('#/contract/order/'+val.id)
            },
            addSettle(val){
                window.open('#/order/3/'+val.id)
            },
            resetSearch(){
                this.form = {}
            },
            changeType(innerTableType){
                this.innerTableType = innerTableType;
                // this.resetSearch();
                console.log(innerTableType)
                this.getData();
            },
            getData(){
                let that = this;
                // let params = Object.assign({}, this.form);

                let url = '';
                this.form.detailType = null
                if(this.innerTableType === 8){
                    url = '/v1/outerformflowHS/getContractInfoList';
                    this.form.detailStatus = null
                    this.form.orderStatus = null
                }else if (this.innerTableType === 9){
                    url='/v1/outerformflowHS/getContractCheckList'
                    this.form.contractStatus = null
                    this.form.orderStatus = null
                    this.form.detailType = '1'
                }else if (this.innerTableType === 10){
                    url='/v1/outerformflowHS/getContractOrderList'
                    this.form.detailStatus = null
                    this.form.contractStatus = null
                    this.form.status = null
                    this.form.sourceType = 2

                }else if (this.innerTableType === 11){
                    url='/v1/outerformflowHS/getContractOrderList'
                    this.form.detailStatus = null
                    this.form.contractStatus = null
                    this.form.sourceType = 1
                }
                this.$root.postHttp(url, this.form, (res) => {
                    // 获取当前时间
                    //     var _this = this;
                    // 　　let yy = new Date().getFullYear();
                    // 　　let mm = new Date().getMonth()+1;
                    // 　　let dd = new Date().getDate();
                    // 　　let hh = new Date().getHours();
                    // 　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
                    // 　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
                    // 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
                    that.tableData = res.data.data.list;
                    that.tableData.forEach(item => {
                        let curDate = new Date().getTime()
                        let tableDate = item.settleableTime ? new Date(item.settleableTime).getTime() : 0
                        item.dateTemp = tableDate ? curDate - tableDate : 0
                        // console.log(item.dateTemp)
                      })
                    that.dataCount = res.data.data.count;
                });
            },
            pageChange(val){
                this.form.pageNumber = val;
                this.getData()
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/_var.scss';
    .search_box{
        text-align: left;
        .el-form-item /deep/{
            width: 500px;
            display: inline-block;
            .el-input__inner{
                border-radius: 0!important;
            }
        }
        .fr{
            float: right;
            color: #333333;
            font-size: 16px;
        }
    }
    #table_box /deep/{
        .table_header th{
            background-color: #F6F6F6!important;
        }

        .el-table th, .el-table td {
            padding: 0px 0;
            font-size: 12px;
        }

        .el-table__body-wrapper {
            font-size: 12px;
        }
        .el-button.el-button--text {
            font-size: 12px;
            padding: 0px;
        }
        .el-table .cell {
            line-height: 32px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/contractTable.vue